<template>
  <div
    v-if="loading || $store.getters.showSiteLoader"
    id="app"
    class="full-page-loader"
  >
    <Loader />
  </div>

  <div
    v-else
    id="app"
  >
    <component :is="layout">
      <b-alert
        ref="successAlert"
        :show="successDismissCountDown"
        variant="success"
        dismissible
        fade
        @dismissed="successDismissCountDown=0"
      >
        {{ $store.getters.globalSuccessAlertText }}
      </b-alert>

      <b-alert
        ref="errorAlert"
        :show="errorDismissCountDown"
        variant="danger"
        dismissible
        fade
        @dismissed="errorDismissCountDown=0"
      >
        {{ $store.getters.globalErrorAlertText }}
      </b-alert>
      <router-view />
    </component>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import UserClient from './api/UserClient';

export default {
  name: 'App',
  components: {
    Loader,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      loading: false,
      successDismissCountDown: 0,
      errorDismissCountDown: 0,
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'default-layout');
    },
  },
  watch: {
    // watch the global alert triggers to show the alert here
    '$store.getters.showGlobalSuccessAlert': function (val, oldVal) {
      if (val) {
        this.successDismissCountDown = this.$store.getters.globalAlertTimeout;

        // hack to add a "open" class when alert appears to have it animate down nicely
        setTimeout(() => {
          this.$refs.successAlert.$el.classList.add('open');
        }, 300);
      } else {
        this.successDismissCountDown = 0;
      }
    },
    '$store.getters.showGlobalErrorAlert': function (val, oldVal) {
      if (val) {
        this.errorDismissCountDown = this.$store.getters.globalAlertTimeout;

        // hack to add a "open" class when alert appears to have it animate down nicely
        setTimeout(() => {
          this.$refs.errorAlert.$el.classList.add('open');
        }, 300);
      } else {
        this.errorDismissCountDown = 0;
      }
    },

    // when we close the alert here, update the global
    successDismissCountDown(val, oldVal) {
      if (val <= 0) {
        this.$store.commit('clearGlobalAlert', false);
      }
    },
    errorDismissCountDown(val, oldVal) {
      if (val <= 0) {
        this.$store.commit('clearGlobalAlert', true);
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await Promise.all([
        this.$now.initialize(),
        this.$user.initialize()
      ])

      if (!this.$user.isInitialized()) {
        await this.goToLinkCampusPage();
        return;
      }

      if (
        this.$router.currentRoute.name === 'home' ||
        this.$router.currentRoute.name === 'home-hash' ||
        this.$router.currentRoute.name === 'link-campus' ||
        this.$router.currentRoute.matched.length === 0
      ) {
        await this.$router.push({
          name: this.$user.getHomeRoute()
        });
      }
    } catch(ex) {
      console.error(ex);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    goToLinkCampusPage() {
      return this.$router.push({
        name: 'link-campus'
      });
    },
  }
};

</script>

<style lang="scss">
@import "/scss/styles.scss";
</style>
